import { NucleusError } from '@nucleus/ncu-error';

const MESSAGE_ATTRIBUTES: Array<keyof Response> = ['status', 'statusText'];

const getMessage = (response: Response): string => {
  return MESSAGE_ATTRIBUTES.reduce((acc, next) => String(response[next]) || acc, '');
};

export class HttpResponseError extends NucleusError {
  name = 'HttpResponseError';
  status: number;
  private response: Response;
  private parsedBody: any = null;
  /** @deprecated */
  body: any;

  // TODO: Remove body from constructor when all usages are removed.
  constructor(response: Response, body?: any) {
    super(getMessage(response));
    this.status = response.status;
    this.response = response;
    this.body = body;
    if (body !== undefined) {
      this.parsedBody = body;
    }
  }

  async getBody<T>(): Promise<T | string | undefined> {
    if (this.parsedBody !== null) {
      return this.parsedBody;
    }

    const response = this.response;
    const contentType = (response.headers.get('Content-Type') ?? '').toLowerCase();
    const contentLength = response.headers.get('Content-Length') ?? 0;

    if (contentLength === '0') {
      this.parsedBody = undefined;
      return;
    }

    if (contentType.includes('application/json')) {
      this.parsedBody = (await response.json()) as T;
    } else {
      this.parsedBody = await response.text();
    }

    return this.parsedBody;
  }
}
